"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useFilterFieldOptions = _interopRequireDefault(require("../useFilterFieldOptions"));

//
function FilterFieldPrice(_ref) {
  var buildFilter = _ref.buildFilter,
      Component = _ref.Component,
      currency = _ref.currency,
      field = _ref.field,
      filter = _ref.filter,
      filterValue = _ref.filterValue,
      onChange = _ref.onChange,
      parentFilter = _ref.parentFilter,
      priceField = _ref.priceField,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["buildFilter", "Component", "currency", "field", "filter", "filterValue", "onChange", "parentFilter", "priceField"]);

  var strategy = _react.default.useMemo(function () {
    return [priceField, currency];
  }, [priceField, currency]);

  var _useFilterFieldOption = (0, _useFilterFieldOptions.default)({
    buildFilter: buildFilter,
    field: field,
    filter: filter,
    parentFilter: parentFilter,
    strategy: strategy
  }),
      _useFilterFieldOption2 = (0, _slicedToArray2.default)(_useFilterFieldOption, 1),
      filterFieldOptions = _useFilterFieldOption2[0];

  var _ref2 = filterFieldOptions || {},
      max = _ref2.max,
      min = _ref2.min;

  var fieldValue = filterValue && filterValue[field] || null;

  var handleChange = _react.default.useCallback(function (v) {
    return onChange({
      field: field,
      value: v || undefined
    });
  }, [field, onChange]);

  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, rest, {
    currency: currency,
    minValue: min,
    maxValue: max,
    onChange: handleChange,
    value: fieldValue
  }));
}

process.env.NODE_ENV !== "production" ? FilterFieldPrice.propTypes = {
  buildFilter: _propTypes.default.func.isRequired,
  Component: _propTypes.default.elementType.isRequired,
  currency: _propTypes.default.string.isRequired,
  field: _propTypes.default.string.isRequired,
  filter: _propTypes.default.shape({}),
  filterValue: _propTypes.default.shape({}),
  onChange: _propTypes.default.func.isRequired,
  parentFilter: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.arrayOf(_propTypes.default.shape({}))]),
  priceField: _propTypes.default.string
} : void 0;
FilterFieldPrice.defaultProps = {
  filter: undefined,
  filterValue: undefined,
  parentFilter: undefined,
  priceField: undefined
};
var _default = FilterFieldPrice;
exports.default = _default;